import { CssVarSpan } from "@/components/CssVarElements"; // The Ask Hopscotch chat mark — a small rotated speech-bubble square.
// This is brand IDENTITY (matches the logo square), not an action: it is
// the ONLY coral in the companion. All controls are ink (see spec color
// rules — coral is reserved for "play" actions elsewhere in the app).

export function AskMark({ size = 22 }: {size?: number;}) {
  return (
    <CssVarSpan
      aria-hidden="true"
      cssVars={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: 'var(--coral)',
        transform: 'rotate(-5deg)',
        boxShadow: '1.5px 1.5px 0 var(--ink)',
        flexShrink: 0
      }}>

      <svg
        width={size * 0.56}
        height={size * 0.56}
        viewBox="0 0 20 20"
        fill="none"
        stroke="#fff"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round">

        <path d="M4 5.5h12v7H9l-3.2 2.6V12.5H4z" />
      </svg>
    </CssVarSpan>);

}